import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import UsersSetRolesModal from './UsersSetRolesModal'
import { setRoles } from 'features/Users/Users.actions'
import { flow } from 'lodash'

const formName = 'setRole'

const stateToProps = (state, { user }) => ({
  initialValues: {
    userId: user.id,
    roles: user.roles,
  },
})

const dispatchToProps = {
  setRoles,
}

export default flow(
  reduxForm({ form: formName }),
  connect(stateToProps, dispatchToProps)
)(UsersSetRolesModal)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Users/UsersSetRolesModal/UsersSetRolesModal.container.js